/* SwanaLume product page script: sticky add-to-cart bar, pack sync,
   "Choose the 2-Pack" and "Change pack". Mode B, 2026-10-05.
   Works with Sense (Dawn 15/16 markup) and Kaching Bundles.
   The bar never adds to the cart itself: it presses the real Add to cart
   button, so Kaching's pack and Sense's cart drawer behave exactly as in
   the buy box. */
(function () {
  var bar = document.getElementById('sl-sticky-atc');
  if (!bar) return;

  var sectionId = bar.getAttribute('data-section');
  var packs = JSON.parse(bar.getAttribute('data-packs'));
  var form = document.getElementById('product-form-' + sectionId);
  var mainBtn = document.getElementById('ProductSubmitButton-' + sectionId);
  var info = document.getElementById('ProductInfo-' + sectionId);
  if (!form || !mainBtn) return;

  var labelEl = bar.querySelector('[data-sl-pack-label]');
  var packBtn = bar.querySelector('[data-sl-pack]');
  var addBtn = bar.querySelector('[data-sl-add]');
  var priceEl = document.querySelector('#price-' + sectionId + ' .price-item--regular');
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* 1. Which pack is chosen.
     Kaching sets the quantity the form submits. [VERIFY in the Kaching trial:
     if the label doesn't follow the ladder, ask Kaching support which element
     holds the selected quantity and add it to getQty.] */
  function ladderBlock() {
    if (!info) return null;
    var own = info.querySelector('[data-sl-ladder]');
    if (own) return own;
    var blocks = info.querySelectorAll('.shopify-app-block');
    for (var i = 0; i < blocks.length; i++) {
      if (blocks[i].querySelector('input[type="radio"]')) return blocks[i];
    }
    return null;
  }

  function getQty() {
    var inputs = document.querySelectorAll('input[name="quantity"]');
    for (var i = 0; i < inputs.length; i++) {
      if (inputs[i].form === form) {
        var q = parseInt(inputs[i].value, 10);
        if (q >= 1) return Math.min(q, 3);
      }
    }
    var block = ladderBlock();
    var radio = block && block.querySelector('input[type="radio"]:checked');
    var r = radio ? parseInt(radio.value, 10) : NaN;
    return r >= 1 && r <= 3 ? r : 1;
  }

  var lastQty = 0;
  function syncPack() {
    var qty = getQty();
    if (qty === lastQty) return;
    lastQty = qty;
    var pack = packs[0];
    for (var i = 0; i < packs.length; i++) if (packs[i].qty === qty) pack = packs[i];
    labelEl.textContent = pack.label + ' \u00b7 ' + pack.price;
    packBtn.setAttribute('aria-label', 'Change pack: ' + pack.label + ', ' + pack.price);
    if (bar.getAttribute('data-sync-price') === 'true' && priceEl) priceEl.textContent = pack.price;
    /* PayPal Pay Later message, if it is PayPal's data-pp-amount element [VERIFY] */
    var pp = info ? info.querySelectorAll('[data-pp-amount]') : [];
    for (var j = 0; j < pp.length; j++) pp[j].setAttribute('data-pp-amount', pack.amount);
  }

  ['change', 'click', 'input'].forEach(function (evt) {
    (info || document).addEventListener(evt, function () {
      window.requestAnimationFrame(syncPack);
    });
  });
  syncPack();

  /* 2. When the bar shows: the real button is off screen and no drawer is open. */
  var buttonInView = true;
  var overlayOpen = false;

  var barMode = bar.getAttribute('data-bar') !== 'false';

  function render() {
    if (!barMode) return; /* homepage buy box: sync only, no sticky bar */
    var show = !buttonInView && !overlayOpen;
    if (bar.hidden === show) bar.hidden = !show;
    if (document.body.classList.contains('sl-sticky-on') !== show) {
      document.body.classList.toggle('sl-sticky-on', show);
    }
  }

  new IntersectionObserver(function (entries) {
    buttonInView = entries[0].isIntersecting;
    render();
  }).observe(mainBtn);

  /* Sense adds overflow-hidden* to <body> while the cart drawer or menu drawer is open */
  function checkOverlays() {
    var open = false;
    document.body.classList.forEach(function (c) {
      if (c.indexOf('overflow-hidden') === 0) open = true;
    });
    if (open !== overlayOpen) {
      overlayOpen = open;
      render();
    }
  }
  new MutationObserver(checkOverlays).observe(document.body, { attributes: true, attributeFilter: ['class'] });
  checkOverlays();

  /* 3. Taps */
  function scrollTo(el, block) {
    el.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: block || 'center' });
  }

  packBtn.addEventListener('click', function () {
    var block = ladderBlock() || mainBtn;
    scrollTo(block);
    var radio = block.querySelector ? block.querySelector('input[type="radio"]:checked') : null;
    (radio || mainBtn).focus({ preventScroll: true });
  });

  addBtn.addEventListener('click', function () {
    if (mainBtn.disabled || mainBtn.getAttribute('aria-disabled') === 'true') return;
    mainBtn.click();
  });

  /* "Adding…" on the bar while Sense adds to the cart */
  new MutationObserver(function () {
    var loading = mainBtn.classList.contains('loading');
    addBtn.textContent = loading ? 'Adding\u2026' : 'Add to cart';
    addBtn.setAttribute('aria-disabled', loading ? 'true' : 'false');
  }).observe(mainBtn, { attributes: true, attributeFilter: ['class'] });

  /* 5. "Choose the 2-Pack" (Giving it section): select that pack in the buy box,
     scroll there and move focus to it. It never adds to the cart (IA §4). */
  document.addEventListener('click', function (event) {
    var trigger = event.target.closest ? event.target.closest('[data-sl-choose]') : null;
    if (!trigger) return;
    event.preventDefault();
    var qty = parseInt(trigger.getAttribute('data-sl-choose'), 10);
    var block = ladderBlock();
    if (!block) {
      scrollTo(mainBtn);
      mainBtn.focus({ preventScroll: true });
      return;
    }
    /* Kaching lists its tiers in order: 1, 2, 3 [VERIFY in the trial] */
    var radios = block.querySelectorAll('input[type="radio"]');
    var target = radios[qty - 1];
    if (target && !target.checked) target.click();
    scrollTo(block);
    (target || mainBtn).focus({ preventScroll: true });
  });

  /* 4. Add-to-cart error: approved wording (Site Copy), and bring it into view */
  var errorText = bar.getAttribute('data-add-error');
  var productForm = form.closest('product-form');
  var errWrap = productForm && productForm.querySelector('.product-form__error-message-wrapper');
  var errMsg = errWrap && errWrap.querySelector('.product-form__error-message');
  if (errWrap && errMsg) {
    new MutationObserver(function () {
      if (!errWrap.hasAttribute('hidden') && errMsg.textContent !== errorText) {
        errMsg.textContent = errorText;
        if (!buttonInView) scrollTo(mainBtn);
      }
    }).observe(errWrap, { attributes: true, childList: true, subtree: true, characterData: true });
  }
  /* 6. "Change pack" from the cart drawer (IA §5). The drawer closes and the
     ladder comes into view. The next Add to cart then SETS the cart line to the
     chosen pack instead of adding more masks: a 2-Pack changed to Single becomes
     1 mask, never 3. [VERIFY in the Kaching trial that Kaching adds through the
     product form; if it adds by its own request, ask Kaching support to respect
     this.] */
  var changeLine = 0;

  document.addEventListener('click', function (event) {
    var link = event.target.closest ? event.target.closest('[data-sl-change-pack]') : null;
    if (!link) return;
    var block = ladderBlock();
    if (!block) return; /* not on the product page: the link simply opens it */
    event.preventDefault();
    changeLine = parseInt(link.getAttribute('data-sl-line'), 10) || 1;
    var drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.close === 'function') drawer.close();
    window.setTimeout(function () {
      scrollTo(block);
      var radio = block.querySelector('input[type="radio"]:checked');
      (radio || mainBtn).focus({ preventScroll: true });
    }, reduceMotion ? 0 : 250);
  });

  document.addEventListener('submit', function (event) {
    if (!changeLine || event.target !== form) return;
    event.preventDefault();
    event.stopPropagation();
    var line = changeLine;
    changeLine = 0;
    mainBtn.classList.add('loading');
    mainBtn.setAttribute('aria-disabled', 'true');
    var url = window.routes && window.routes.cart_change_url ? window.routes.cart_change_url : '/cart/change.js';
    fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        line: line,
        quantity: getQty(),
        sections: ['cart-drawer', 'cart-icon-bubble'],
        sections_url: window.location.pathname
      })
    })
      .then(function (response) { return response.json(); })
      .then(function (state) {
        if (state.status) throw new Error(state.description || 'Cart error');
        var drawer = document.querySelector('cart-drawer');
        if (drawer && typeof drawer.renderContents === 'function') drawer.renderContents(state);
        else window.location.href = '/cart';
      })
      .catch(function () {
        if (errWrap && errMsg) {
          errMsg.textContent = errorText;
          errWrap.removeAttribute('hidden');
        }
      })
      .then(function () {
        mainBtn.classList.remove('loading');
        mainBtn.removeAttribute('aria-disabled');
      });
  }, true);
})();
